import { FC, Fragment, useContext } from 'react';

import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import { cdnUrl } from '../constants';
import { withErrorBoundary } from '@bepro-travel/fe.shared';
import { Page, PageItem } from '../types';
import CarouselMain from './CarouselMain';
import OphirSearchBox from './OphirSearchBox';

interface SliderSearchCmsProps {
  searchBox?: string;
  slider?: PageItem;
  page?: Page;
}

const SliderSearch: FC<SliderSearchCmsProps> = ({ searchBox, slider, page }) => {
  const lang = localStorage.getItem('language') || 'he';
  const navigate = useNavigate();
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: window.innerWidth < 768 ? 1 : 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    rtl: lang === 'he',
    arrows: true,
  };

  const isLayout1 = !!slider && slider?.attrubuteLayout === 'Layout_1';
  const isLayout2 = !!slider && slider?.attrubuteLayout === 'Layout_2';

  return (
    <Fragment>
      {(!!searchBox || !!slider) && (
        <section
          className={
            'main-page-search' +
            (searchBox === 'Multi' && isLayout1 ? ' main-page-search-multi' : '') +
            (isLayout2 ? ' main-page-search-2' : '')
          }
          style={{ order: slider?.orderDisplay }}
        >
          {!!slider?.slider && isLayout1 && (
            <div className="main-page-carousel">
              <CarouselMain listOfGalleryId={slider.slider.listOfGalleryId}></CarouselMain>
            </div>
          )}
          {!!slider?.slider && isLayout2 && (
            <Slider {...settings}>
              {slider.slider.listOfGalleryId.map((item, index) => (
                <img
                  key={index}
                  src={cdnUrl + item.code}
                  alt={item.alt}
                  onClick={() =>
                    navigate(item.listOfLangs.find((item: any) => item.language.code === 'He')?.url)
                  }
                />
              ))}
            </Slider>
          )}
          {!!searchBox && <OphirSearchBox page={page} searchBox={searchBox} />}
        </section>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(SliderSearch, 'SliderSearch');
